<script>
import PrimaryButton from "@/components/PrimaryButton";
import TimeDimensionRow from "./ClassicTimeDimensionRow";

export default {
  name: "ClassicTimeDimensionsTab",
  components: {
    PrimaryButton,
    TimeDimensionRow
  },
  data() {
    return {
      totalUpgrades: 0,
      multPerTickspeed: 0,
      tickspeedSoftcap: 0,
      timeShards: new Decimal(0),
      upgradeThreshold: new Decimal(0),
      shardsPerSecond: new Decimal(0),
      incomeType: "",
      areAutobuyersUnlocked: false,
      showLockedDimCostNote: true,
    };
  },
  computed: {
    costIncreases: () => TimeDimension(1).costIncreaseThresholds,
  },
  methods: {
    update() {
      this.showLockedDimCostNote = !TimeDimension(8).isUnlocked && player.realities >= 1;
      this.totalUpgrades = player.totalTickGained;
      this.multPerTickspeed = FreeTickspeed.multToNext;
      this.tickspeedSoftcap = FreeTickspeed.softcap;
      this.timeShards.copyFrom(Currency.timeShards);
      this.upgradeThreshold.copyFrom(FreeTickspeed.fromShards(Currency.timeShards.value).nextShards);
      this.shardsPerSecond.copyFrom(TimeDimension(1).productionPerRealSecond);
      this.incomeType = EternityChallenge(7).isRunning ? "Восьмые Измерения Бесконечности" : "Осколки Времени";
      this.areAutobuyersUnlocked = Autobuyer.timeDimension(1).isUnlocked;
    },
    maxAll() {
      tryUnlockTimeDimensions();
      maxAllTimeDimensions();
    },
    toggleAllAutobuyers() {
      toggleAllTimeDims();
    }
  }
};
</script>

<template>
  <div class="l-time-dim-tab l-centered-vertical-tab">
    <div class="c-subtab-option-container">
      <PrimaryButton
        class="o-primary-btn--subtab-option"
        @click="maxAll"
      >
        Макс Все
      </PrimaryButton>
      <PrimaryButton
        v-if="areAutobuyersUnlocked"
        class="o-primary-btn--subtab-option"
        @click="toggleAllAutobuyers"
      >
        Переключить все АвтоПокупщики
      </PrimaryButton>
    </div>
    <div>
      <p>
        Вы заработали
        <span class="c-time-dim-description__accent">{{ formatInt(totalUpgrades) }}</span> улучшений Скорости Тика с
        <span class="c-time-dim-description__accent">{{ format(timeShards, 2, 1) }}</span> Осколков Времени.
      </p>
      <p>
        Следующее улучшение Скорости Тика в
        <span class="c-time-dim-description__accent">{{ format(upgradeThreshold, 2, 1) }}</span>, повышение на
        <span class="c-time-dim-description__accent">{{ formatX(multPerTickspeed, 2, 2) }}</span> за
        полученное улучшение Скорости Тика.
      </p>
    </div>
    <div>
      Количество, которое требует каждое новое улучшение
      начнёт расти после {{ formatInt(tickspeedSoftcap) }} улучшений Скорости Тика.
    </div>
    <div>
      Вы получаете {{ format(shardsPerSecond, 2, 0) }} {{ incomeType }} в секунду.
    </div>
    <div class="l-dimensions-container">
      <TimeDimensionRow
        v-for="tier in 8"
        :key="tier"
        :tier="tier"
        :are-autobuyers-unlocked="areAutobuyersUnlocked"
      />
    </div>
    <div>
      Цена Измерений Времени подскакивает на {{ format(costIncreases[0], 2, 2) }} и
      {{ format(costIncreases[1]) }} Очках Вечности,
      <br>
      также цены увеличиваются гораздо быстрее после {{ format(costIncreases[2]) }} Очков Вечности.
      <br>
      <div v-if="showLockedDimCostNote">
        Зажмите шифт чтобы увидеть стоимость в Очках Вечности для заблокированных Измерений Времени.
      </div>
      Любые 8ые Измерения Времени, купленные после {{ format(1e8) }}, не будут больше увеличивать множитель.
    </div>
  </div>
</template>
